/** @format */

export const DEFAULT_TEST_ID = 'video-block';
